import { Injectable } from '@angular/core';
var BsDatepickerActions = (function () {
    function BsDatepickerActions() {
    }
    BsDatepickerActions.prototype.calculate = function (viewDate) {
        return {
            type: BsDatepickerActions.CALCULATE,
            payload: viewDate
        };
    };
    BsDatepickerActions.prototype.format = function () {
        return {
            type: BsDatepickerActions.FORMAT
        };
    };
    BsDatepickerActions.prototype.flag = function () {
        return {
            type: BsDatepickerActions.FLAG
        };
    };
    BsDatepickerActions.prototype.select = function (date) {
        return {
            type: BsDatepickerActions.SELECT,
            payload: date
        };
    };
    BsDatepickerActions.prototype.navigateStep = function (step) {
        return {
            type: BsDatepickerActions.STEP_NAVIGATION,
            payload: step
        };
    };
    BsDatepickerActions.prototype.renderOptions = function (options) {
        return {
            type: BsDatepickerActions.RENDER_OPTIONS,
            payload: options
        };
    };
    // date range picker
    BsDatepickerActions.prototype.selectRange = function (value) {
        return {
            type: BsDatepickerActions.SELECT_RANGE,
            payload: value
        };
    };
    BsDatepickerActions.prototype.hover = function (event) {
        return {
            type: BsDatepickerActions.HOVER,
            payload: event.isHovered ? event.day.date : null
        };
    };
    BsDatepickerActions.CALCULATE = '[datepicker] calculate dates matrix';
    BsDatepickerActions.FORMAT = '[datepicker] format datepicker values';
    BsDatepickerActions.FLAG = '[datepicker] set flags';
    BsDatepickerActions.SELECT = '[datepicker] select date';
    BsDatepickerActions.STEP_NAVIGATION = '[datepicker] shift view date';
    BsDatepickerActions.RENDER_OPTIONS = '[datepicker] update render options';
    BsDatepickerActions.HOVER = '[datepicker] hover date';
    BsDatepickerActions.SELECT_RANGE = '[daterangepicker] select dates range';
    BsDatepickerActions.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    BsDatepickerActions.ctorParameters = function () { return []; };
    return BsDatepickerActions;
}());
export { BsDatepickerActions };
//# sourceMappingURL=bs-datepicker.actions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/datepicker/reducer/bs-datepicker.actions.js
// module id = 112
// module chunks = 103